import EventManager from "../../../../manager/event_manager";
import Utility from "../../../../utility/utility";

const { ccclass, property } = cc._decorator;

@ccclass
export default class MailItem extends cc.Component{
    @property(cc.Label)
    labelTitle: cc.Label = null

    @property(cc.Label)
    labelTitle_selected: cc.Label = null

    @property(cc.Label)
    labelTime: cc.Label = null

    @property(cc.Label)
    labelTime_selected: cc.Label = null

    @property(cc.Node)
    nodeOpenTag: cc.Node = null

    @property(cc.Node)
    nodeUnOpenTag: cc.Node = null

    @property(cc.Node)
    nodeGettedTag: cc.Node = null

    @property(cc.Node)
    nodeUnGettedTag: cc.Node = null

    @property(cc.Node)
    nodeSelectBg: cc.Node = null

    @property(cc.Node)
    nodeUnSelectBg: cc.Node = null

    @property(cc.Node)
    nodeButton: cc.Node = null

    show(show: boolean, data: any){        
        this.node.active = !!show
        if(show){
            let titleText = Utility.filterPlayerName(data.title, 18)
            let contentText = Utility.filterPlayerName(data.content, 10)
            let createTime = Utility.timeToStr(Number(data.createTime), 'dd/MM/yyyy        hh:mm:ss')
            let selected = data.selected
            this.labelTitle.string = titleText
            this.labelTitle_selected.string = titleText
            this.labelTime.string = createTime
            this.labelTime_selected.string = createTime

            this.labelTitle.node.active = !selected
            this.labelTime.node.active = !selected

            this.labelTitle_selected.node.active = !!selected
            this.labelTime_selected.node.active = !!selected

            this.nodeSelectBg.active = !!selected
            this.nodeUnSelectBg.active = !selected

            this.nodeOpenTag.active = data.status != 1
            this.nodeUnOpenTag.active = data.status == 1

            this.nodeGettedTag.active = !!(data.attachs && data.attachs.length > 0 && data.attachStatus == 2)
            this.nodeUnGettedTag.active = !!(data.attachs && data.attachs.length > 0 && data.attachStatus == 1)
            // if(data.attachs && data.attachs.length > 0 && data.attachStatus == 1){
            //     let pos = cc.v2(-120, this.labelTitle.node.position.y)
            //     this.labelTitle.node.position = pos
            //     this.labelTitle_selected.node.position = pos
            // }else{
            //     let pos = cc.v2(-242, this.labelTitle.node.position.y)
            //     this.labelTitle.node.position = pos
            //     this.labelTitle_selected.node.position = pos
            // }
        }
        this.nodeButton.targetOff(this)
        this.nodeButton.on('click', function(){
            Utility.playButtonSound();
            EventManager.instance.dispatch('click_mail_item', data)
        }, this)
    }

}